import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";

import { Device } from "@devices/types";
import { getActiveConnectionType, getDeviceConnectionIcon, getDeviceConnectionLabel } from "@devices/utils/device";
import { Box, Theme } from "@mui/material";

const useStyles = makeStyles<{ isOnline: boolean }>()((theme: Theme, { isOnline }) => ({
    root: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    icon: {
        color: isOnline ? theme.palette.emteria.success : theme.palette.emteria.error,
    },
}));

export const ConnectionStatus = ({ device }: { device: Device | null }) => {
    const { t } = useTranslation(["common", "sidepanels"]);
    const isOnline = Boolean(device?.isOnline);
    const { classes } = useStyles({ isOnline });

    const connectionType = getActiveConnectionType(device?.lastState?.networks, isOnline);
    const connectionIcon = getDeviceConnectionIcon(connectionType, isOnline);

    let text: string;
    if (isOnline) {
        const connectionLabel = getDeviceConnectionLabel(connectionType);
        text = connectionLabel
            ? t("sidepanels:devicePanel.status.onlineWithConnection", { connection: connectionLabel })
            : t("common:status.online");
    } else {
        text = t("sidepanels:devicePanel.status.offline");
    }

    return (
        <Box className={classes.root}>
            <i className={clsx("fa-solid", connectionIcon, classes.icon)} />
            <span>{text}</span>
        </Box>
    );
};
